import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        borderBottom: '1px solid #EEEEEE',
        '& .MuiTab-wrapper': {
            fontSize: theme.spacing(1.75),
        },
        '& .Mui-selected': {
            color: `${theme.colors.primary.main} !important`,
        },
        '& .Mui-disabled': {
            color: `${theme.colors.gray[200]} !important`,
        },
        '& .Mui-selected:hover': {
            borderRadius: `${theme.spacing(1)} ${theme.spacing(1)} 0 0 !important`,
        },
        '& .MuiTabs-indicator': {
            transition: '0s',
            height: theme.spacing(0.5),
            backgroundColor: theme.colors.primary.main,
            borderRadius: '2px 2px 0 0',
        },
        '& .MuiTab-root': {
            minWidth: 100,
            padding: theme.spacing(1.5, 3),
            fontWeight: 600,
            fontSize: 12,
            color: theme.colors.text[700],
            '&:hover': {
                backgroundColor: theme.colors.gray[0],
                borderRadius: theme.spacing(1),
            },
        },
    },
}));
//# sourceMappingURL=Tabs.styles.js.map